import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Mail, Lock, Loader2, TrendingUp } from "lucide-react";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); 
  const [isLoading, setIsLoading] = useState(false); 
  
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      // const response = await fetch("http://localhost:10001/api/admin/login", {
      const response = await fetch("https://motilalalgo.com/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

     if (response.ok && data.success) {
  localStorage.setItem("motilal_admin_token", data.token);
  localStorage.setItem("motilal_admin_user", JSON.stringify(data.user));

  navigate("/moti-lal/dashboard"); 
} else {
        setError(data.error || "Invalid Credentials! Please try again.");
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError("Server connection failed. Is your backend running?");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f9fc] flex font-[Urbanist]">
      
      {/* Left Side - Branding (Hidden on Mobile) */}
      <div className="hidden lg:flex w-1/2 bg-[#2d2780] text-white flex-col justify-center items-center p-12 relative overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-[#3b36a4] rounded-full blur-3xl opacity-50"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-indigo-500/20 rounded-full blur-3xl"></div>
        
        <div className="z-10 text-center max-w-md">
          <div className="w-20 h-20 bg-white text-[#2d2780] rounded-2xl flex items-center justify-center mx-auto mb-8 shadow-2xl">
            <TrendingUp size={44} strokeWidth={2.5} />
          </div>
          <h1 className="text-4xl font-black mb-4 tracking-tight">Motilal Terminal</h1>
          <p className="text-indigo-200 text-lg leading-relaxed font-medium">
            Advanced Algorithmic Trading Control Panel. Monitor signals and manage portfolios securely.
          </p>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12">
        <div className="max-w-md w-full bg-white p-8 sm:p-10 rounded-[2rem] shadow-xl shadow-slate-200/50 border border-slate-100">
          
          <div className="text-center mb-8">
            <div className="lg:hidden w-12 h-12 bg-[#2d2780] rounded-xl flex items-center justify-center mx-auto mb-4">
               <TrendingUp size={24} className="text-white" />
            </div>
            <h2 className="text-3xl font-black text-slate-800">Admin Login</h2>
            <p className="text-slate-500 mt-2 text-sm font-medium">Secure access to the control panel</p>
          </div>

          {error && (
            <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 text-sm rounded-xl flex items-center gap-3">
               <ShieldCheck size={20} className="text-red-500 shrink-0" />
               <span className="font-bold">{error}</span>
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="block text-sm font-bold text-slate-700 mb-2 ml-1">Email Address</label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none transition-colors group-focus-within:text-[#3b36a4]">
                  <Mail size={18} className="text-slate-400" />
                </div>
                <input 
                  type="email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required 
                  disabled={isLoading}
                  className="w-full pl-11 pr-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-4 focus:ring-[#3b36a4]/10 focus:border-[#3b36a4] outline-none transition-all text-slate-800 font-medium placeholder:text-slate-400 placeholder:font-normal" 
                  placeholder="admin@motilalalgo.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-bold text-slate-700 mb-2 ml-1">Password</label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none transition-colors group-focus-within:text-[#3b36a4]">
                  <Lock size={18} className="text-slate-400" />
                </div>
                <input 
                  type="password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                  disabled={isLoading}
                  className="w-full pl-11 pr-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-4 focus:ring-[#3b36a4]/10 focus:border-[#3b36a4] outline-none transition-all text-slate-800 font-medium placeholder:text-slate-400 placeholder:font-normal" 
                  placeholder="••••••••"
                />
              </div>
            </div>
            
            <button 
              type="submit" 
              disabled={isLoading}
              className="w-full mt-2 bg-[#3b36a4] hover:bg-[#2d2780] text-white font-black py-4 rounded-xl shadow-lg shadow-indigo-500/20 transition-all active:scale-[0.98] disabled:opacity-70 flex justify-center items-center gap-2"
            >
              {isLoading ? (
                <><Loader2 size={20} className="animate-spin" /> Verifying...</>
              ) : (
                'Login Securely'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;